import { Button, Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import FreePlanGraphic from '../../../graphics/FreePlanGraphic'

const FreePlanCTA = (): React.ReactElement => {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <Flex direction="column" align="center" justify="center">
      <FreePlanGraphic width="260px" height="200px" marginTop="8em" />
      <Text
        as="h3"
        color="appDarkIndigo"
        fontWeight="semibold"
        marginTop="3em"
        fontSize="1.25em"
      >
        {t('upgrade_to_paid_plan', 'Upgrade to Paid Plan')}
      </Text>
      <Text
        marginTop="1.25em"
        fontSize="1em"
        fontWeight="semibold"
        color="appBattleshipGrey"
        align="center"
      >
        {t(
          'upgrade_to_paid_plan_info',
          'This feature is available upon upgrading to paid plan',
        )}
      </Text>
      <Button
        marginTop="2em"
        onClick={() => {
          history.push('/upgrade-plan')
        }}
      >
        {t('upgrade_now', 'Upgrade Now')}
      </Button>
    </Flex>
  )
}

export default FreePlanCTA
